/**
 * Determines the Practice Booster Signatures API URL based on the current environment.
 *
 * @type {string}
 * @throws {Error} Throws an error if an unrecognized React App environment is detected.
 * @example
 * // Usage
 * import pbSignaturesApiUrl from './path/to/your/file';
 *
 * console.log(pbSignaturesApiUrl); // Outputs the determined API URL
 */
const pbSignaturesApiUrl = (() => {
    switch (process.env.REACT_APP_ENV) {
        case 'development': {
            return 'http://localhost:8080'; // Development API URL
        }
        case 'testing': {
            return 'http://localhost:8080'; // Testing API URL
        }
        case 'production': {
            return 'https://signature-api.practicebooster.com'; // Production API URL
        }
        default: {
            throw new Error('Unrecognized React App Environment');
        }
    }
})();
export default pbSignaturesApiUrl;
